import { createElement, Props as ReactProps, ReactElement } from 'react';
import { DependencyProps } from '../../../core/dependency';
import { LocationProps } from '../../../core/location';
import { StateProps } from '../../../core/state';
import { Layout, Spin } from 'antd';
import styled from 'styled-components';
import applyGlobalStyles from '../../../applyGlobalStyles';

type Props = ReactProps<HTMLDivElement> &
  DependencyProps &
  StateProps &
  LocationProps & {
    content: ReactElement<any> | ReactElement<any>[];
    movePageConfirmEnable?: boolean;
    modalSpinner?: boolean;
    isSpinner?: boolean;
  };

const StyledLayout = styled(Layout)`
  width: 100%;
  height: 100%;
`;

const StyledContentContainer = styled.div`
  overflow: auto;
  height: 100%;
`;

const RootFrame = (
  {
    content,
    isSpinner = false,
  }
: Props) => (
  <StyledLayout>
    <StyledContentContainer>
      {isSpinner ? <Spin>{content}</Spin> : content}
    </StyledContentContainer>
    {applyGlobalStyles()}

  </StyledLayout>
);

export default RootFrame;
